import React from 'react';

export * from './MyAppRouter';

export * from './HomePage';
export const AboutPage = () => <div> This is About Page </div>;
export * from './AccountPage';
export * from './UserListPage';

export * from './ClassRoomPage';
export * from './ClassListPage';
export * from './ClassPage';


export * from './QuizListPage';
export * from './QuizPage';
